import {
  RECEIVE_SHIPMENT_TRACKING,
  RECEIVE_SHIPMENT_TRACKING_ERROR,
  REQUEST_SHIPMENT_TRACKING,
  RESET_SHIPMENT_TRACKING
} from 'constants/reduxActions';
import { fetchErrorMiddlewareMaybeJson } from 'middleware/fetchErrorMiddleware';
import { getAuthTracking, getGuestTracking } from 'apis/account';
import { trackError } from 'helpers/ErrorUtils';
import { selectAccountConfig } from 'selectors/environment';
import { extractEmailAuthToken, isEmailAuthTokenPresent } from 'helpers/AuthHelpers';

export function requestShipmentTracking() {
  return {
    type: REQUEST_SHIPMENT_TRACKING
  };
}

export function receiveShipmentTracking(trackingInfo) {
  return {
    type: RECEIVE_SHIPMENT_TRACKING,
    trackingInfo
  };
}

export function receiveShipmentTrackingError() {
  return {
    type: RECEIVE_SHIPMENT_TRACKING_ERROR
  };
}

export function resetShipmentTracking() {
  return {
    type: RESET_SHIPMENT_TRACKING
  };
}

export function fetchShipmentTracking(orderId, shipmentId) {
  return (dispatch, getState) => {
    dispatch(requestShipmentTracking());

    const state = getState();
    const accountConfig = selectAccountConfig(state);
    const { cookies, router } = state;
    const isGuest = isEmailAuthTokenPresent({ getState });

    if (isGuest) {
      const authToken = extractEmailAuthToken(router);
      return getGuestTracking(accountConfig, orderId, shipmentId, cookies, authToken)
        .then(fetchErrorMiddlewareMaybeJson)
        .then(resp => {
          dispatch(receiveShipmentTracking(resp));
        })
        .catch(e => {
          trackError('NON-FATAL', 'Problem loading guest shipment tracking data.', e);
          dispatch(receiveShipmentTrackingError());
        });
    }

    return getAuthTracking(accountConfig, orderId, shipmentId, cookies)
      .then(fetchErrorMiddlewareMaybeJson)
      .then(resp => {
        dispatch(receiveShipmentTracking(resp));
      })
      .catch(e => {
        trackError('NON-FATAL', 'Problem loading auth shipment tracking data.', e);
        dispatch(receiveShipmentTrackingError());
      });
  };
}
